<footer>
    <div>
      <!--<div class="footer-logo" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
        <img src="./assets/images/footer-logo-icon.png" />
        <span style="color:black; top:-15px !important; padding-top:0px !important" class="trademark">™</span>
      </div>-->
<div class="footer-des" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
    <p style="margin-bottom: 0px !important; padding: 0px !important
    ;">Titanium Secure Services, LLC</p>
        <p style="margin-bottom: 0px !important; padding: 0px !important
    ;">6106 Yellowstone Rd.</p>
        <p style="margin-bottom: 0px !important; padding: 0px !important
    ;">Cheyenne, WY 82009</p>
        <p style="margin-bottom: 0px !important; padding: 0px !important
    ;">803-820-1000</p>
        <p style="margin-bottom: 0px !important; padding: 0px !important
    ;"><a style="color:white!important" href="mailto:info@titaniumcomms.com">info@titaniumcomms.com</a></p>
</div>

        <div class="footer-copyright" style="color:white" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">&copy; 2021-2026 Titanium Secure Services, LLC. All rights reserved.</div>
        <div>
          We do not use cookies for profiling or advertising. Please see our  
          <a style="color:white!important" href="https://www.titaniumsecure.io/privacy-policy" target="_blank">Privacy Policy</a>
          
          &nbsp;  &nbsp;
          <br>
          <!--<a [routerLink]="['/privacy-policy']">Privacy Policy</a>-->
          <a style="color:white!important" href="https://www.titaniumsecure.io/service-aggrement" target="_blank">Terms of Use</a>
          &nbsp;  &nbsp;
          <!--<a style="color:white!important" href="https://www.titaniumsecure.io/feedback">Feedback</a>-->
        </div>
    </div>
</footer>
